<template>
    <div>
      <create-kktc-eInvoice-list></create-kktc-eInvoice-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>